import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { EventParams } from '@app/core/interfaces';
import { AnalyticsProfile } from '@app/pages/shared/interfaces/viewer-profile.interface';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAnalyticsService {
  private pageEnterTime: number | null = null;
  private pageName: string | null = null;
  private dialogName: string | null = null;
  private dialogEnterTime: number | null = null;

  constructor(public analytics: AngularFireAnalytics) {}

  onLogin(params: AnalyticsProfile) {
    this.analytics.setUserId(params?._id ?? '');
    this.analytics.setUserProperties(params);
  }

  onUpdateProfile(params: AnalyticsProfile) {
    this.analytics.setUserProperties(params);
  }

  logDialogOpen(popupName: string, params?: EventParams) {
    this.dialogEnterTime = new Date().getTime();
    this.dialogName = popupName;
    let modifiedPopupName = popupName.replaceAll(' ', '_');
    this.analytics.logEvent(`${modifiedPopupName}_open`, {
      dialogName: popupName,
      dialogEnterTime: new Date().toISOString(),
      ...params,
    });
  }

  logPageOpen(pageName: string, params?: EventParams) {
    this.pageEnterTime = new Date().getTime();
    this.pageName = pageName;
    let modifiedPageName = pageName.replaceAll(' ', '_');
    this.analytics.logEvent(`${modifiedPageName}_open`, {
      pageName,
      pageEnterTime: new Date().toISOString(),
      ...params,
    });
  }

  logCustomEvent(eventName: string, eventParams: EventParams) {
    let modifiedEventName = eventName.replaceAll(' ', '_');
    this.analytics.logEvent(modifiedEventName, eventParams);
  }

  logAPIFailure(failEventName: string, eventParams: EventParams) {
    let modifiedFailureEvent = failEventName.replaceAll(' ', '_');
    this.analytics.logEvent(modifiedFailureEvent, {
      ...eventParams,
      logTime: new Date().toISOString(),
    });
  }

  logPageExit() {
    if (this.pageEnterTime && this.pageName) {
      const timeSpent = new Date().getTime() - this.pageEnterTime;
      const timeSpentInSeconds = (timeSpent / 1000).toFixed(2);
      console.info(
        `Time spend ${timeSpentInSeconds} seconds on ${this.pageName}`
      );
      this.analytics.logEvent(`${this.pageName}_exit`, {
        pageName: this.pageName,
        timeSpent: timeSpentInSeconds,
        pageExitTime: new Date().toISOString(),
      });
      this.pageEnterTime = null;
      this.pageName = null;
    }
  }

  logDialogClosed() {
    if (this.dialogEnterTime && this.dialogName) {
      const timeSpent = new Date().getTime() - this.dialogEnterTime;
      const timeSpentInSeconds = (timeSpent / 1000).toFixed(2);
      console.info(
        `Time spend ${timeSpentInSeconds} seconds on ${this.dialogName}`
      );
      this.analytics.logEvent(`${this.dialogName}_exit`, {
        dialogName: this.pageName,
        timeSpent: timeSpentInSeconds,
        dialogExitTime: new Date().toISOString(),
      });
      this.dialogEnterTime = null;
      this.dialogName = null;
    }
  }
}
